<style lang="scss" scoped>
.saveData {
    margin: 10px auto;
    display: block;
}
.el-input__inner {
    width: 280px;
}
.operator {
    display: flex;
    color: #409eff;
    cursor: pointer;
    span {
        margin-right: 10px;
        &:last-child {
            margin-right: 0px;
        }
    }
}

.tabelFormDialog {
    width: 1400px;
    margin: 0 auto;
    .el-form-item {
        margin-bottom: 20px;
    }
    .addBtn {
        display: block;
        margin: 0px auto;
        margin-top: 40px;
    }
}
.edit_base_info_form {
    .el-form-item__content,
    .el-date-editor.el-input,
    .el-select,
    .el-cascader,
    .el-input {
        width: 290px;
    }
}

.editForm {
    width: 820px;
    .tableStyleSet {
        .el-form-item__content {
            width: 600px;
            margin: 0 auto !important;
        }
    }
}
.el-dialog__body {
    width: 590px;
}
</style>
<template>
    <el-form
        ref="ruleForm"
        :model="ruleForm"
        label-width="300px"
        class="flexbox edit_base_info_form"
    >
        <div class="editForm">
            <div
                v-for="item, index in ruleForm.field"
                :key="index"
                v-if="displayRule(item)"
            >
                <el-form-item
                    v-if="item._item_type!='serial_number'"
                    :label="item.name + '：'"
                    :prop="'field.'+index+'.value'"
                    :rules="getRules(item)"
                >
                    <!--文本框-->
                    <el-tooltip
                        effect="dark"
                        placement="right"
                        :disabled="item.tip==''"
                    >
                        <div
                            slot="content"
                            v-html="item.tip"
                        ></div>

                        <el-input
                            v-if="item.type == 1&&item._item_type!='mobile_num'&&item._item_type!='email'"
                            v-model="item.value"
                            :maxlength="256"
                            :placeholder="'请输入'+item.name+'信息'"
                            @input="getPinYIn(item)"
                            :disabled="item.fixed==''||item.is_readonly"
                        ></el-input>
                        <!-- 处理后台手机和邮箱加密 -->
                        <el-input
                            v-if="item.type == 1&&(item._item_type=='mobile_num'||item._item_type=='email')"
                            v-model="item.value"
                            :maxlength="256"
                            :placeholder="'请输入'+item.name+'信息'"
                            @change="handleEncryption(item)"
                            :disabled="item.fixed==''||item.is_readonly"
                        ></el-input>
                        <!--单选框（选项个数<=2）-->
                        <el-radio-group
                            v-if="item.type == 2 && item.sub_confs.length<=2"
                            v-model="item.value"
                        >
                            <el-radio
                                :label="subItem.value"
                                v-for="subItem in item.sub_confs"
                                :key="subItem.value"
                                :disabled="item.fixed==''||item.is_readonly"
                            >{{subItem.value}}</el-radio>
                        </el-radio-group>
                        <!--单选框（选项个数>2）-->
                        <el-select
                            v-if="item.type == 2 && item.sub_confs.length>2"
                            v-model="item.value"
                            :clearable="!item.is_required"
                            :filterable="true"
                            placeholder="请选择"
                            :disabled="item.fixed==''||item.is_readonly"
                        >
                            <el-option
                                v-for="subItem in item.sub_confs"
                                :key="subItem.value"
                                :label="subItem.value"
                                :value="subItem.value"
                            ></el-option>
                        </el-select>
                        <!--多选框-->
                        <el-select
                            :disabled="item.is_readonly"
                            v-if="item.type == 3"
                            v-model="item.value"
                            multiple
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="subItem in item.sub_confs"
                                :key="subItem.value"
                                :label="subItem.value"
                                :value="subItem.value"
                            ></el-option>
                        </el-select>
                        <!--日期选择-->
                        <el-date-picker
                            v-if="item.type == 4"
                            v-model="item.value"
                            :picker-options="DateOpt"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            :clearable="!item.is_required"
                            type="date"
                            :editable="false"
                            :default-value="setDefaultTime(item.sub_confs)"
                            @focus="setDateLimit(item)"
                            placeholder="选择日期"
                            :disabled="item.is_readonly"
                        ></el-date-picker>
                        <!--级联选择-->
                        <el-cascader
                            v-if="item.type == 7"
                            :options="item.sub_confs"
                            filterable
                            v-model="item.value"
                            :disabled="item.is_readonly"
                        ></el-cascader>
                        <template v-if="item.type==8">
                            <div class="table_title">
                                <div>
                                    <el-button
                                        type="primary"
                                        round
                                        @click="addTableInfo(item)"
                                        v-if="!item.is_readonly"
                                    >添加</el-button>
                                </div>
                            </div>
                        </template>
                    </el-tooltip>
                </el-form-item>
                <el-form-item
                    v-if="item.type==8"
                    class="tableStyleSet"
                >
                    <!--表格类型-->
                    <template v-if="item.type == 8">
                        <div
                            class="reg_info_table"
                            v-if="item.sections"
                        >
                            <template>
                                <el-table
                                    :data="item.value"
                                    style="width: 100%"
                                >
                                    <template v-for="itm in item.sections">
                                        <el-table-column
                                            :prop="itm.tag"
                                            :label="itm.name"
                                            min-width="120"
                                            v-if="itm._item_type!='sequence'"
                                        ></el-table-column>
                                        <el-table-column
                                            v-else
                                            type="index"
                                            :prop="itm.tag"
                                            :label="itm.name"
                                            width="120"
                                        ></el-table-column>
                                    </template>
                                    <el-table-column
                                        label="操作"
                                        v-if="!item.is_readonly"
                                        min-width="140"
                                    >
                                        <template slot-scope="scope">
                                            <div class="operator">
                                                <span
                                                    class="check_btn"
                                                    @click="editTableRow(scope.$index, scope.row,item)"
                                                >修改</span>
                                                <span
                                                    class="check_btn"
                                                    @click="delTableRow(scope.$index, scope.row,item)"
                                                >删除</span>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                            <!-- 表格添加 -->
                            <!-- <el-dialog
                title="信息编辑"
                :visible.sync="dialogVisible"
                style="width：800px;"
                :before-close="handleClose"
                :append-to-body="true"
                custom-class="tabelFormDialog"
              >
                <div>
                  <ruleFormCom
                    :ruleForm="tableRuleForm"
                    :btnName="btnName"
                    @handleFormSubmit="getFormData"
                    :btnClass="'addBtn'"
                  ></ruleFormCom>
                </div>
              </el-dialog> -->
                            <ruleFormCom
                                class="tabelFormDialog"
                                :tableRuleForm="tableRuleForm"
                                :btnName="btnName"
                                @handleFormSubmit="getFormData"
                                :btnClass="'addBtn'"
                                @on-result-change="handleClose"
                                :ruleFormDialogVisible="dialogVisible"
                                :appendToBody="true"
                            ></ruleFormCom>
                        </div>
                    </template>
                </el-form-item>
                <el-form-item
                    v-if="item.type == 1 && item.sub_confs.enable_pinyin"
                    :label="item.name + '拼音：'"
                    :prop="'field.'+index+'.py_value'"
                    :rules="getPinyinRules(item)"
                >
                    <el-tooltip
                        effect="dark"
                        :content="item.name+'拼音'"
                        placement="right"
                    >
                        <el-input
                            :placeholder="'请输入'+item.name+'拼音'"
                            @input="changePy(item)"
                            v-model="item.py_value"
                        ></el-input>
                    </el-tooltip>
                </el-form-item>
            </div>
            <el-button
                type="primary"
                class="saveData"
                @click="formSubmit"
            >保存</el-button>
        </div>
    </el-form>
</template>
<script type="text/ecmascript-6">
import "../../assets/js/pinyinUtil";
import ruleFormCom from "@components/tableRuleForm/tableRuleForm";
export default {
    components: {
        ruleFormCom
    },
    data() {
        var validateChecked = (rule, value, callback) => {
            if (value == "") {
                callback(new Error("请再核对信息并上传正确的照片"));
            } else {
                callback();
            }
        };
        return {
            DateOpt: {
                disabledDate: time => {
                    let isDate = new Date(
                        this.$common.formatDate(time, "yyyy-MM-dd")
                    );
                    if (this.dateLimit.begin_datetime) {
                        if (this.dateLimit.end_datetime) {
                            return (
                                isDate.getTime() >
                                    new Date(
                                        this.dateLimit.end_datetime
                                    ).getTime() ||
                                isDate.getTime() <
                                    new Date(
                                        this.dateLimit.begin_datetime
                                    ).getTime()
                            );
                        }
                        return (
                            isDate.getTime() <
                            new Date(this.dateLimit.begin_datetime).getTime()
                        );
                    }
                    if (this.dateLimit.end_datetime) {
                        return (
                            isDate.getTime() >
                            new Date(this.dateLimit.end_datetime).getTime()
                        );
                    }
                }
            },
            validCardId: (rule, value, callback) => {
                var cardType = null;
                this.ruleForm.field.forEach(item => {
                    if (item._item_type == "cert_type") {
                        cardType = item.value;
                    }
                });
                if (cardType == "居民身份证") {
                    if (!this.$common.validateChinaCt(value)) {
                        callback(new Error("证件号码不正确"));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            },
            validZipCode: (rule, value, callback) => {
                var re = /^[0-9]{6}$/;
                if (re.test(value)) {
                    callback();
                } else {
                    callback(new Error("邮政编码不正确"));
                }
            },
            validMobileNum: (rule, value, callback) => {
                if (value != "") {
                    if (this.isMobileChange) {
                        if (this.$common.validMobileNum(value)) {
                            callback();
                        } else {
                            callback(new Error("手机号不正确"));
                        }
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            },
            validEmail: (rule, value, callback) => {
                if (value != "") {
                    if (this.isEmailChange) {
                        if (this.$common.validEmail(value)) {
                            callback();
                        } else {
                            callback(new Error("邮箱号不正确"));
                        }
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            },
            rules: {
                name: [
                    { required: true, message: "请输入姓名", trigger: "blur" }
                ],
                sex: [
                    { required: true, message: "请选择性别", trigger: "change" }
                ],
                birth_date: [
                    {
                        type: "date",
                        required: true,
                        message: "请选择出生年月",
                        trigger: "change"
                    }
                ],
                checked: [
                    {
                        required: true,
                        validator: validateChecked,
                        trigger: "change"
                    }
                ]
            },
            tableRuleForm: {
                field: []
            },
            isMobileChange: false,
            isEmailChange: false,
            operatorTableIndex: "", //当前操作的表格index
            editTableRowIdx: "", //当前操作的表格value值index
            btnName: "add", //add为添加，edit为编辑
            dialogVisible: false,
        };
    },
    props: {
        ruleForm: {
            type: Object,
            default: function() {
                return {
                    field: []
                };
            }
        },
        loading: {
            type: Boolean,
            default: false
        },
        regId: {
            type: String,
            default: ""
        },
        btnClass: {
            type: String,
            default: ""
        }
    },
    watch: {
        loading(val) {
            if (!val) {
                this.ruleForm.field.forEach(item => {
                    if (item._item_type == "name" && !item.py_value) {
                        this.getPinYIn(item);
                    }
                    if (item.type == 4) {
                        item.value = item.value;
                    }
                    if (item.type == 8) {
                        item.value = item.value == "" ? [] : item.value;
                    }
                    if (item.type == 7) {
                        if (typeof item.value == "string") {
                            let list = [];
                            item.value.split("/").forEach((n, index) => {
                                list.push(
                                    item.value
                                        .split("/")
                                        .slice(0, index + 1)
                                        .join("/")
                                );
                            });
                            item.value = list;
                        }
                    }
                });
            }
        }
    },
    methods: {
        handleEncryption(item) {
            if (item._item_type == "mobile_num") {
                this.isMobileChange = true;
            } else if (item._item_type == "email") {
                this.isEmailChange = true;
            }
        },
        getFormData(val) {
            this.dialogVisible = false;
            this.ruleForm.field.map(item => {
                if (item.index == this.operatorTableIndex) {
                    if (this.btnName == "add") {
                        item.value.push(val);
                    } else {
                        item.value.splice(this.editTableRowIdx, 1, val);
                    }
                }
            });
        },
        editTableRow(idx, row, item) {
            this.editTableRowIdx = idx;
            this.operatorTableIndex = item.index;
            item.sections.forEach(item => {
                Object.keys(row).forEach(key => {
                    if (key == item.tag) {
                        item.value = row[key];
                    }
                });
            });
            this.tableRuleForm.field = item.sections;
            this.btnName = "edit";
            this.dialogVisible = true;
        },
        delTableRow(idx, row, item) {
            this.$confirm("是否确定删除？", "提示信息", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    this.editTableRowIdx = idx;
                    this.operatorTableIndex = item.index;
                    this.ruleForm.field.map(item => {
                        if (item.index == this.operatorTableIndex) {
                            item.value.splice(this.editTableRowIdx, 1);
                        }
                    });
                })
                .catch(() => {});
        },
        addTableInfo(item) {
            this.operatorTableIndex = item.index;
            this.tableRuleForm.field = item.sections;
            this.tableRuleForm.field.forEach(item => {
                item.value = "";
            });
            this.btnName = "add";
            this.dialogVisible = true;
        },
        handleClose(val) {
            this.dialogVisible = val;
        },
        formSubmit: function() {
            this.$refs["ruleForm"].validate(valid => {
                if (valid) {
                    let formData = [];
                    this.ruleForm.field.forEach(item => {
                        if (item.is_pass) {
                            if (item.type == 4) {
                                formData.push({
                                    name: item.name,
                                    value: item.value,
                                    type: item.type,
                                    _item_type: item._item_type,
                                    tag: item.tag,
                                    is_required: item.is_required
                                });
                            } else if (item.type == 7) {
                                formData.push({
                                    name: item.name,
                                    value:
                                        item.value.length == 0
                                            ? item.value.length
                                            : item.value[item.value.length - 1],
                                    type: item.type,
                                    _item_type: item._item_type,
                                    tag: item.tag,
                                    is_required: item.is_required
                                });
                            } else if (
                                item.type == 1 &&
                                item.sub_confs.enable_pinyin
                            ) {
                                formData.push({
                                    name: item.name,
                                    value: item.value,
                                    py_value: item.py_value,
                                    type: item.type,
                                    _item_type: item._item_type,
                                    tag: item.tag,
                                    is_required: item.is_required
                                });
                            } else {
                                formData.push({
                                    name: item.name,
                                    value: item.value,
                                    type: item.type,
                                    _item_type: item._item_type,
                                    tag: item.tag,
                                    is_required: item.is_required
                                });
                            }
                        }
                    });
                    this.$emit("handleBaseInfoSubmit", formData);
                    this.$refs["ruleForm"].resetFields();
                    this.ruleForm.field = [];
                } else {
                }
            });
        },
        getPinYIn: function(item) {
            if (item.sub_confs.enable_pinyin) {
                var n = pinyinUtil.getPinyin(item.value).toUpperCase();
                var j,
                    num = 0;
                if (n) {
                    for (let i of n.split(" ")) {
                        if (n.indexOf(i) == 0 && num == 0) {
                            num++;
                            j = i + " ";
                        } else {
                            j = j + i;
                        }
                    }
                }
                item.py_value = j;
            }
        },
        displayRule(item) {
            if (item.rules != null && item.rules.length > 0) {
                for (let i of item.rules) {
                    for (let j of this.ruleForm.field) {
                        if (j.tag == i.tag) {
                            if (displayRuleType[i.condition]) {
                                if (j.type == 3) {
                                    let states = true;
                                    for (let option of i.value) {
                                        if (j.value.indexOf(option) == -1) {
                                            states = false;
                                        }
                                    }
                                    if (!states) {
                                        if (item.type == 8) {
                                            item.value = [];
                                        } else {
                                            item.value = "";
                                        }
                                        item.is_pass = false;
                                        return false;
                                    }
                                } else {
                                    if (i.value.indexOf(j.value) == -1) {
                                        if (item.type == 8) {
                                            item.value = [];
                                        } else {
                                            item.value = "";
                                        }
                                        item.is_pass = false;
                                        return false;
                                    }
                                }
                            } else {
                                if (!j.value) {
                                    if (item.type == 8) {
                                        item.value = [];
                                    } else {
                                        item.value = "";
                                    }
                                    item.is_pass = false;
                                    return false;
                                }
                            }
                        }
                    }
                }
                item.is_pass = true;
                return true;
            } else {
                item.is_pass = true;
                return true;
            }
        },
        changePy(item) {
            item.py_value = item.py_value.toUpperCase();
            this.ruleForm.field.splice(
                this.ruleForm.field.indexOf(item),
                1,
                item
            );
        },
        getRules: function(item) {
            // 证件号码验证，仅当证件类型为居民身份证时验证格式
            if (item.type == 1 && item._item_type == "cert_id") {
                if (item.is_required) {
                    return [
                        {
                            required: true,
                            message: item.name + "不能为空",
                            trigger: "blur"
                        },
                        {
                            validator: this.validCardId,
                            trigger: "blur"
                        }
                    ];
                } else {
                    return [
                        {
                            validator: this.validCardId,
                            trigger: "blur"
                        }
                    ];
                }
            }
            if (
                item.type == 1 &&
                item._item_type == "zip_code" &&
                item.is_required
            ) {
                if (item.is_required) {
                    return [
                        {
                            required: true,
                            message: item.name + "不能为空",
                            trigger: "blur"
                        },
                        {
                            validator: this.validZipCode,
                            trigger: "blur"
                        }
                    ];
                } else {
                    return [
                        {
                            validator: this.validZipCode,
                            trigger: "blur"
                        }
                    ];
                }
            }
            if (item.type == 1 && item._item_type == "mobile_num") {
                if (item.is_required) {
                    return [
                        {
                            required: true,
                            message: item.name + "不能为空",
                            trigger: "blur"
                        },
                        {
                            validator: this.validMobileNum,
                            trigger: "blur"
                        }
                    ];
                } else {
                    return [
                        {
                            validator: this.validMobileNum,
                            trigger: "blur"
                        }
                    ];
                }
            }
            if (item.type == 1 && item._item_type == "email") {
                if (item.is_required) {
                    return [
                        {
                            required: true,
                            message: item.name + "不能为空",
                            trigger: "blur"
                        },
                        {
                            validator: this.validEmail,
                            trigger: "blur"
                        }
                    ];
                } else {
                    return [
                        {
                            validator: this.validEmail,
                            trigger: "blur"
                        }
                    ];
                }
            }
            // 下面4种为标准表单验证
            if (item.type == 1 && item.is_required) {
                return {
                    required: true,
                    message: item.name + "不能为空",
                    trigger: "blur"
                };
            } else if (item.type == 2 && item.is_required) {
                return {
                    required: true,
                    message: item.name + "不能为空",
                    trigger: "change"
                };
            } else if (item.type == 3 && item.is_required) {
                return {
                    type: "array",
                    required: true,
                    message: item.name + "不能为空",
                    trigger: "change"
                };
            } else if (item.type == 4 && item.is_required) {
                return {
                    required: true,
                    message: item.name + "不能为空",
                    trigger: "change"
                };
            } else if (item.type == 7 && item.is_required) {
                return {
                    type: "array",
                    required: true,
                    message: item.name + "不能为dd空",
                    trigger: "change"
                };
            } else if (item.type == 8 && item.is_required) {
                return {
                    type: "array",
                    required: true,
                    message: item.name + "不能为空",
                    trigger: "change"
                };
            }
        },
        setDefaultTime: function(item) {
            let d1 = new Date(item.begin_datetime);
            let d2 = new Date(item.end_datetime);
            if (item.begin_datetime && item.end_datetime) {
                let d3 = new Date((d2.getTime() + d1.getTime()) / 2);
                return d3;
            } else if (item.begin_datetime) {
                let d3 = new Date(d1.getTime() + 3600000 * 24);
                return d3;
            } else if (item.end_datetime) {
                let d3 = new Date(d2.getTime() - 3600000 * 24);
                return d3;
            } else {
                return "";
            }
        },
        getPinyinRules: function(item) {
            if (item.type == 1 && item.sub_confs.enable_pinyin) {
                return {
                    required: true,
                    message: item.name + "拼音不能为空",
                    trigger: "blur"
                };
            }
        },
        setDateLimit: function(item) {
            this.dateLimit = item.sub_confs;
        }
    }
};
</script>